namespace Nobox.CRM {
    export interface GroupsRow {
        Id?: number;
        Name?: string;
        OwnerId?: number;
        TnId?: number;
        Owner?: string;
        Image?: string;
        Web?: string;
        Telephone?: string;
        Address?: string;
        Latitude?: string;
        Longitude?: string;
        Country?: string;
        State?: string;
        City?: string;
        ZipCode?: string;
        Industry?: string;
        Type?: string;
        Source?: string;
        GrpId?: number;
        In?: string;
        InBy?: number;
        Up?: string;
        UpBy?: number;
        Grp?: string;
    }

    export namespace GroupsRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Name';
        export const localTextPrefix = 'Nobox.Groups';
        export const lookupKey = 'Nobox.Groups';

        export function getLookup(): Q.Lookup<GroupsRow> {
            return Q.getLookup<GroupsRow>('Nobox.Groups');
        }
        export const deletePermission = 'Group:Delete';
        export const insertPermission = 'Group:Modify';
        export const readPermission = 'Group:View';
        export const updatePermission = 'Group:Modify';

        export declare const enum Fields {
            Id = "Id",
            Name = "Name",
            OwnerId = "OwnerId",
            TnId = "TnId",
            Owner = "Owner",
            Image = "Image",
            Web = "Web",
            Telephone = "Telephone",
            Address = "Address",
            Latitude = "Latitude",
            Longitude = "Longitude",
            Country = "Country",
            State = "State",
            City = "City",
            ZipCode = "ZipCode",
            Industry = "Industry",
            Type = "Type",
            Source = "Source",
            GrpId = "GrpId",
            In = "In",
            InBy = "InBy",
            Up = "Up",
            UpBy = "UpBy",
            Grp = "Grp"
        }
    }
}
